import { useVerifyUserQuery } from "api/authApi";

export const ALLOWED_ROLES = ["SUPPLIER", "DROPSHIPPER"];

/**
 * Auth state derived from the verify-user API (reactive).
 * Session cache alone does not trigger re-renders after OAuth redirects.
 */
export function useAuthUser() {
  const { data: user, isSuccess, isLoading, isError } = useVerifyUserQuery();

  const isAuthenticated =
    isSuccess && user && ALLOWED_ROLES.includes(user.role);

  return { user, isAuthenticated, isLoading, isError };
}
